import { t } from '@/i18n';
import { z } from 'zod';

export const reportFileType = z.enum(['pdf', 'csv']);

export const projectDetailUrlTypeEnum = z.enum(['public', 'admin']);
export const ProjectDetailUrlTypeLabelModifier = {
  public: t('project-detail-url-type-public'),
  admin: t('project-detail-url-type-admin'),
} as const satisfies Record<z.infer<typeof projectDetailUrlTypeEnum>, string>;

export const reportRsBatchTargetType = z.enum([
  'rs-report1', // 様式1
  'rs-report2', // 様式2
  'rs-report3', // 様式3
  'rs-report4', // 様式4
  'rs-report5', // 様式5
  'ks-standard-list', // 基金一覧
  'ks-local-government-list-A', // 地方公共団体等基金一覧A表
  'ks-local-government-list-B', // 地方公共団体等基金一覧B表
  'ks-investment-list', // 出資状況表一覧
]);

export const ReportBatchTargetLabelModifier = {
  [reportRsBatchTargetType.Values['rs-report1']]: t('report-format1'),
  [reportRsBatchTargetType.Values['rs-report2']]: t('report-format2'),
  [reportRsBatchTargetType.Values['rs-report3']]: t('report-format3'),
  [reportRsBatchTargetType.Values['rs-report4']]: t('report-format4'),
  [reportRsBatchTargetType.Values['rs-report5']]: t('report-format5'),
} as const;
